import React from "react";
import { Col, Row, Container } from "react-bootstrap";
import Back from '../Back/back';
import Theme from '../Theme/theme';
import "./footer.scss";
import Flag from "../../images/US-flag.svg";
import Logo from "../Logo/logo";

const Footer = () => {

    const getCurrentYear = () => {
        return new Date().getFullYear();
    };

    const scrollToSection = (id) => {
        const section = document.getElementById(id);
        if (section) {
            section.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <footer className="footer" id="contact">  
            <Container fluid>
                <Container>
                    <Row>
                        <Col xs={12} className="d-flex justify-content-between">
                            <Logo />
                            <img src={Flag} alt="US Flag" className="footer-flag" />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <nav className="d-flex flex-column gap-3">
                                <a href="#backToTop" onClick={(e) => { e.preventDefault(); scrollToSection("backToTop"); }}>HOME</a>
                                <a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection("services"); }}>SERVICES</a>
                                <a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection("contact"); }}>CONTACT</a>
                            </nav>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <p><a href="tel:603-770-2677">603-770-2677</a><br/><a href="mailto:titanundercoating360@gmail.com" target="_blank" rel="noopener noreferrer">titanundercoating360@gmail.com</a></p>
                            <p className="small" style={{ marginTop: "24px" }}>&copy; {getCurrentYear()} Titan Mobile Undercoating. All rights reserved.</p>
                            <p className="small" style={{ marginTop: "24px" }}>Site built by: <a href="https://www.webdesignofboston.com"  target="_blank" rel="noopener noreferrer">Web Design of Boston</a></p>
                        </Col>
                    </Row>
                </Container>
            </Container>
            <Back />
            <Theme />
        </footer>
    );
};

export default Footer;